<template>
  <header
    id="site-header"
    class="site-header"
    :class="{ 'open' : isOpen }"
  >
    <div class="content-max-width flex">

      <a href="/" class="logo">
        <img src="/images/logo-new.svg" alt="Host Service Logo" />
      </a>

      <div class="desktop-nav">
        <ul>
          <li
            v-for="(nav, index) in desktop"
            :key="index"
          >
            <!-- <a @click="toggleProducts()">prdct</a> -->
            <a v-if="nav.url === '/products'" @click="toggleProducts()">{{ nav.title }}</a>
            <a v-else-if="nav.url === '/commercial-kitchen-design-and-build'" :href="nav.url" >Commercial Kitchen/Build</a>
            <a v-else :href="nav.url">{{ nav.title }}</a>
          </li>
        </ul>
      </div>

      <button
        class="search-button"
        @click="toggleSearch()"
      >
        <img src="/images/ico-search.svg" alt="Host Service Search">
      </button>

      <a
        class="cart-button"
        @click="toggleCart()"
      >
        <img src="/images/ico-cart.svg" alt="Host Service Cart">
        <span class="amount" v-if="$store.state.cartCount">{{ $store.state.cartCount }}</span>
      </a>

      <button
        class="hamburger"
        @click="toggleMenu()"
      >
        <span></span><span></span><span></span>
      </button>
    </div>

    <nav class="mobile-nav">
      <ul class="mobile">
        <li
          v-for="(nav, index) in desktop"
          :key="index"
        >
          <a
            v-if="nav.url === '/products'"
            :href="nav.url"
          >
            Products
          </a>
          <span
            v-if="nav.url === '/products'"
            class="toggle"
            @click="toggleMobileProducts()"
          >
            <span v-if="isMobProductsOpen">-</span>
            <span v-else>+</span>
          </span>

          <ul
            v-if="nav.url === '/products'"
            class="child"
            v-show="isMobProductsOpen"
          >
            <li
              v-for="product of categories"
              :key="product.id"
            >
              <a :href="product.url">
                {{ product.title }}
              </a>
            </li>
          </ul>
          <a v-else :href="nav.url">{{ nav.title }}</a>
        </li>
      </ul>

      <ul>
        <li v-for="(nav, index) in accountnav" :key="index">
          <a :href="nav.url">{{ nav.title }}</a>
        </li>
      </ul>
      <ul>
        <li v-for="(nav, index) in companynav" :key="index">
          <a v-if="nav.url == '/products'" :href="'/categories'">{{ nav.title }}</a>
          <a v-else :href="nav.url">{{ nav.title }}</a>
        </li>
      </ul>
      <ul>
        <li v-for="(nav, index) in infonav" :key="index">
          <a :href="nav.url">{{ nav.title }}</a>
        </li>
      </ul>
    </nav>

    <div
      v-show="isProductsOpen"
      class="products-dropdown desktop"
    >
      <div class="content-max-width" v-show="!isProductsChildrenOpen">
        <div class="flex">

          <article
            v-for="product of categories"
            :key="product.id"
          >
            <!-- <a :href="product.url"> -->
            <a @click="toggleChldrenProducts(product)">
              <div class="image">
                <img :src="product.image" :alt="product.title">
              </div>
              <h4>{{ product.title }}</h4>
            </a>
          </article>

        </div>
      </div>

      <div class="content-max-width children-cats" v-show="isProductsChildrenOpen">

        <h3 @click="closeChldrenProducts()">
          <img src="/images/back.png" alt="Host Service Products">
          {{ childrenCatTitle }}
        </h3>

        <div class="flex">
          <article
            v-for="product of childrenCat"
            :key="product.id"
          >

            <a @click="toggleChldrenProducts(null,product)" v-if="product.children.length > 0">
              <div class="image">
                <img :src="product.image" :alt="product.title">
              </div>
              <h4>{{ product.title }}</h4>
            </a>
            <a v-else :href="product.url">
              <div class="image">
                <img :src="product.image" :alt="product.title">
              </div>
              <h4>{{ product.title }}</h4>
            </a>
          </article>
        </div>
      </div>

    </div>

    <HeaderSearch
      v-if="isSearchOpen"
      :suggested="suggested"
    ></HeaderSearch>

  </header>
</template>

<script>
import HeaderSearch from './HeaderSearch.vue'

export default {
  props: [
    'csrf', 'menu', 'categories', 'suggested', 'desktop', 'companynav', 'infonav','accountnav', 'isLoggedIn'
  ],

  components: {
    HeaderSearch
  },

  data () {
    return {
      isOpen: false,
      isSearchOpen: false,
      isProductsOpen: false,
      isProductsChildrenOpen: false,
      isMobProductsOpen: false,
      childrenCat: [],
      childrenCatTitle: '',
      parentProduct: null,
      prevProduct: null
    };
  },

  mounted () {
    // console.log(this.desktop)
    if (this.isLoggedIn) {
      this.$store.commit('setLogin', null)
    } else {
      this.$store.commit('setLogout')
    }
  },

  methods: {

    toggleMenu () {
      if (!this.isOpen) {
        this.isOpen = true
        this.$parent.isMenuOpen = true
      } else {
        this.closeMenus()
      }
    },

    toggleSearch () {
      if (!this.isSearchOpen) {
        this.isSearchOpen = true
        this.$parent.isMenuOpen = true
      } else {
        this.closeMenus()
      }
    },

    toggleProducts () {
      if (!this.isProductsOpen) {
        this.isProductsOpen = true
        this.$parent.isMenuOpen = true
      } else {
        this.closeMenus()
      }
    },

    toggleChldrenProducts (product, childProduct) {
      if (product) {
        this.isProductsChildrenOpen = !this.isProductsChildrenOpen
        this.childrenCat = product.children
        this.childrenCatTitle = product.title
        this.parentProduct = product
      }

      if (childProduct) {
          this.isProductsChildrenOpen = true
          this.prevProduct = childProduct
          this.childrenCat = this.prevProduct.children
          this.childrenCatTitle = this.prevProduct.title
      }

    },

    closeChldrenProducts () {
      if (this.prevProduct) {
          this.isProductsChildrenOpen = true
          this.childrenCat = this.parentProduct.children
          this.childrenCatTitle = this.parentProduct.title
          this.prevProduct = null
      } else if (this.prevProduct === null && this.parentProduct) {
            this.isProductsChildrenOpen = false
            this.parentProduct = null
      } else {
        this.isProductsChildrenOpen = false
        this.childrenCat = []
      }

    },

    toggleCart () {
      console.log(this.$parent.isCartOpen)
      this.$parent.isCartOpen = !this.$parent.isCartOpen
    },

    closeMenus () {
      this.isProductsOpen = false
      this.isSearchOpen = false
      this.isOpen = false
      this.$parent.isMenuOpen = false
    },

    toggleMobileProducts () {
      this.isMobProductsOpen = !this.isMobProductsOpen
    }

  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Header.vue